import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from '@shared/authentication/data-access';

/* Http interceptor providers in outside-in order */
export const MYACCOUNT_HTTP_INTERCEPTOR_PROVIDERS = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
